import { useEffect, useRef } from 'react'
import { toast } from '@workwhile/ui'
import { defs } from './defs'

type PageLoadingToastProps = {
  isLoading: boolean
  message: string
}

export const PageLoadingToast = ({
  isLoading,
  message,
}: PageLoadingToastProps) => {
  const loadingToastIdRef = useRef<string | number | null>(null)

  useEffect(() => {
    if (isLoading) {
      if (loadingToastIdRef.current !== null) {
        toast.dismiss(loadingToastIdRef.current)
      }
      loadingToastIdRef.current = toast.loading(message, {
        position: 'top-right',
        autoClose: false,
        draggable: false,
        style: {
          backgroundColor: defs.alertYellow,
        },
      })
    } else if (loadingToastIdRef.current !== null) {
      toast.dismiss(loadingToastIdRef.current)
      loadingToastIdRef.current = null
    }

    return () => {
      if (loadingToastIdRef.current !== null) {
        toast.dismiss(loadingToastIdRef.current)
        loadingToastIdRef.current = null
      }
    }
  }, [isLoading, message])

  return null
}
